import { useState } from "preact/hooks";
import { strings } from "../i18n/strings.es-AR.js";
import { sendText } from "../hooks/useConversation.js";
import { Icon } from "./icons.jsx";

// Las listas interactivas del pipeline (menú post-identificación, elección de
// cuenta por DNI) se muestran como bottom-sheet. Elegir una fila envía su
// título como texto, igual que en WhatsApp.
export function ListPicker({ message }) {
  const [open, setOpen] = useState(false);
  const list = message?.list;
  const sections = Array.isArray(list?.sections) ? list.sections : [];
  if (sections.length === 0) return null;

  const choose = (row) => {
    setOpen(false);
    sendText(row.title);
  };

  return (
    <div class="mt-2 pl-1">
      <button
        type="button"
        class="rounded-full border border-flux-primary/40 bg-white px-3.5 py-1.5 text-sm text-flux-navy shadow-sm active:bg-flux-primary/10 dark:border-flux-cyan/40 dark:bg-slate-800 dark:text-flux-cyan"
        onClick={() => setOpen(true)}
      >
        <span class="flex items-center gap-1.5">
          <Icon name="list" size={14} /> {list.button || strings.listPickerOpen}
        </span>
      </button>

      {open && (
        <div class="fixed inset-0 z-20 flex items-end bg-black/40" onClick={() => setOpen(false)}>
          <div
            class="scroll-light max-h-[75vh] w-full overflow-y-auto rounded-t-2xl bg-white p-4 safe-bottom dark:bg-slate-900"
            onClick={(e) => e.stopPropagation()}
          >
            <div class="mb-3 flex items-center justify-between">
              <h2 class="text-sm font-semibold text-slate-900 dark:text-white">{strings.listPickerTitle}</h2>
              <button type="button" class="text-xs text-slate-400" onClick={() => setOpen(false)}>
                {strings.listPickerClose}
              </button>
            </div>
            {sections.map((section) => (
              <div key={section.title} class="mb-3">
                {section.title && (
                  <p class="mb-1 text-xs font-medium uppercase tracking-wide text-slate-400">
                    {section.title}
                  </p>
                )}
                <div class="divide-y divide-slate-100 dark:divide-slate-800">
                  {(section.rows || []).map((row) => (
                    <button
                      key={row.id || row.title}
                      type="button"
                      class="block w-full py-2.5 text-left active:bg-slate-50 dark:active:bg-slate-800"
                      onClick={() => choose(row)}
                    >
                      <span class="block text-sm text-slate-800 dark:text-slate-100">{row.title}</span>
                      {row.description && (
                        <span class="block text-xs text-slate-500 dark:text-slate-400">{row.description}</span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
